import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '@shared/components/icon/icon.module';

import { EnvironmentBannerComponent } from './environment-banner.component';

@NgModule({
  imports: [
    CommonModule,
    IconModule
  ],
  declarations: [EnvironmentBannerComponent],
  exports: [EnvironmentBannerComponent]
})
export class EnvironmentBannerModule { }
